
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import VisionSection from './components/VisionSection';
import ServicesSection from './components/ServicesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import ContactFormSection from './components/ContactFormSection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <VisionSection />
        <ServicesSection />
        <TestimonialSection />
        <CTASection />
        <ContactFormSection />
      </main>
      <Footer />
    </div>
  );
}
